export const getName = (d: any) => d.name || d.Name;
export const getTitle = (d: any) => d.title || d.Title;

// Функция для разбиения массива на чанки
export function chunkArray<T>(array: T[], chunkSize: number): T[][] {
  const chunks: T[][] = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    chunks.push(array.slice(i, i + chunkSize));
  }
  return chunks;
}
